import { Close } from 'components/gruenland/icons/Close';
import Slider360 from 'components/gruenland/molecules/image-slider-360/Slider360';

type Props = {
  image360: string;
  onClose: () => void;
};

const Modal360: React.FC<Props> = ({ image360, onClose }) => (
  <div
    className="fixed inset-0 z-50 flex size-full items-center justify-center overflow-y-auto bg-[#7f7f7f]/30"
    onClick={onClose}
  >
    <div className="relative rounded-md bg-white p-6" onClick={(e) => e.stopPropagation()}>
      <button onClick={onClose} className="absolute right-2 top-2 p-[3px]">
        <Close />
      </button>

      <Slider360 sprite={image360} className="mx-auto hidden md:block" />
    </div>
  </div>
);

export default Modal360;
